var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _g, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 296,
    viewBox: "0 0 281 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16689_2119)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.272278 288.267H279.925",
    stroke: "#272525",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.609 20.1685L234.932 140.435",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.687 33.0031L220.682 0.408691L218.83 3.32231",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.147 140.653C232.027 136.096 237.546 136.096 238.436 140.653C238.436 140.653 248.12 141.724 251.315 147.306H218.276C221.471 141.724 231.156 140.653 231.156 140.653H231.147Z",
    fill: "#7798FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.787 141.615C235.438 141.615 235.967 141.087 235.967 140.435C235.967 139.783 235.438 139.255 234.787 139.255C234.135 139.255 233.607 139.783 233.607 140.435C233.607 141.087 234.135 141.615 234.787 141.615Z",
    fill: "#272525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.398 5.06527C216.543 -2.25055 223.722 2.63271 219.184 11.0377C219.184 11.0377 223.459 19.9147 219.102 28.3288L194.35 11.5097C200.577 4.35728 210.398 5.06527 210.398 5.06527Z",
    fill: "#7798FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.259 11.6369C192.689 13.9514 196.955 19.5971 203.79 24.2444C210.625 28.8917 217.441 30.7796 219.011 28.4651C220.237 26.6679 217.931 22.8466 213.629 19.0616C212.404 17.9815 211.006 16.8923 209.49 15.8666C207.974 14.8319 206.449 13.9424 204.997 13.1981C199.887 10.5931 195.494 9.84878 194.268 11.655L194.259 11.6369Z",
    fill: "#7798FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.259 11.6369C192.689 13.9514 196.955 19.5971 203.79 24.2444C210.625 28.8917 217.441 30.7796 219.011 28.4651C220.237 26.6679 217.931 22.8466 213.629 19.0616C212.404 17.9815 211.006 16.8923 209.49 15.8666C207.974 14.8319 206.449 13.9424 204.997 13.1981C199.887 10.5931 195.494 9.84878 194.268 11.655L194.259 11.6369Z",
    fill: "#7798FF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.362 13.9333C202.71 16.3567 203.345 19.6606 205.769 21.3126C208.192 22.9646 211.496 22.3292 213.148 19.9057C213.339 19.6334 213.493 19.343 213.62 19.0525C212.395 17.9724 210.997 16.8832 209.481 15.8575C207.965 14.8228 206.44 13.9333 204.988 13.189C204.761 13.4159 204.552 13.67 204.371 13.9423L204.362 13.9333Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.362 13.9331C202.71 16.3566 203.345 19.6605 205.769 21.3125C208.192 22.9644 211.496 22.329 213.148 19.9056",
    stroke: "#272525",
    strokeWidth: 0.22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.979 4.5752C211.151 4.5752 211.342 4.65689 211.505 4.71135C211.659 4.76581 211.823 4.82027 211.977 4.8838C212.286 5.01088 212.594 5.1561 212.903 5.30133C213.52 5.60086 214.128 5.9367 214.709 6.30884C215.853 7.03498 216.906 7.90634 217.841 8.8957C218.104 9.168 218.34 9.44938 218.576 9.74891C218.821 10.0484 219.021 10.3661 219.22 10.6929C219.293 10.8109 219.111 10.9016 219.03 10.82C218.794 10.584 218.549 10.357 218.313 10.1211C218.077 9.88506 217.841 9.64907 217.596 9.42215C217.35 9.18616 217.151 9.00462 216.906 8.79586C216.652 8.57802 216.397 8.36925 216.134 8.16049C215.108 7.33451 213.992 6.62653 212.821 6.01839C212.739 5.97301 212.658 5.9367 212.576 5.89132C212.576 5.89132 212.558 5.88224 212.549 5.88224C212.531 5.88224 212.513 5.86409 212.494 5.85501C212.458 5.83686 212.413 5.8187 212.376 5.80055C212.213 5.71886 212.041 5.64625 211.868 5.56455C211.696 5.49194 211.532 5.41025 211.36 5.33764C211.278 5.30133 211.187 5.26502 211.106 5.21964C211.006 5.17426 210.897 5.12887 210.806 5.06534C210.597 4.91103 210.706 4.56612 210.97 4.58427L210.979 4.5752Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.35
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.093 28.3286L203.445 149.384L32.5036 150.573L194.867 10.9286C201.965 8.50509 221.961 23.0913 219.093 28.3286Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.261 200.676H128.453L136.404 130.623H195.212L187.261 200.676Z",
    fill: "#F8C358"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186 195.33H94.2069V200.676H186V195.33Z",
    fill: "#F8C358"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.349 284.745H195.485L181.997 141.242H175.861L189.349 284.745Z",
    fill: "#F8C358"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.052 288.031C194.976 287.813 196.338 286.188 196.102 284.409L195.185 277.556L188.223 278.355L189.14 285.208C189.376 286.987 191.128 288.258 193.052 288.031Z",
    fill: "#272525"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.562 285.435H163.698L150.21 141.242H144.074L157.562 285.435Z",
    fill: "#F8C358"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.266 288.72C163.19 288.502 164.551 286.878 164.315 285.099L163.399 278.246L156.437 279.044L157.353 285.897C157.589 287.676 159.341 288.947 161.266 288.72Z",
    fill: "#272525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 285.435H92.673L100.987 198.008H107.123L98.8088 285.435Z",
    fill: "#F8C358"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1055 288.72C93.1813 288.502 91.8198 286.878 92.0558 285.099L92.9725 278.246L99.9343 279.044L99.0176 285.897C98.7816 287.676 97.0298 288.947 95.1055 288.72Z",
    fill: "#272525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.595 285.897H124.46L137.938 142.386H144.074L130.595 285.897Z",
    fill: "#F8C358"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.892 289.174C124.968 288.956 123.606 287.332 123.842 285.553L124.759 278.7L131.721 279.498L130.804 286.351C130.568 288.13 128.816 289.401 126.892 289.174Z",
    fill: "#272525"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.105 195.33H186",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4786 214.836L32.5036 236.285C32.5036 236.285 37.7862 238.817 48.1246 240.169L63.9271 218.975L48.4786 214.836Z",
    fill: "#E89B8C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7011 251.225L5.34613 240.414C5.34613 240.414 6.66225 233.099 14.3411 233.979C22.5465 234.923 30.4432 236.412 31.3327 235.404C32.2222 234.406 31.8319 232.218 32.9847 231.238C33.8016 230.548 35.6441 230.303 35.9346 231.456C36.4792 233.598 34.8181 235.241 36.2069 236.094C40.0917 238.463 45.9825 238.98 47.3077 238C48.6329 237.029 50.4845 239.407 48.5512 241.985C46.3728 244.889 47.3712 248.683 45.7193 251.216L45.7011 251.225Z",
    fill: "#F8C358"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7973 242.383L45.1712 253.201L45.7022 251.219L5.32823 240.401L4.7973 242.383Z",
    fill: "#272525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4651 234.233C23.8626 235.159 30.5067 236.321 31.3236 235.404L30.3342 239.098C30.3342 239.098 16.2018 238.49 16.4651 234.233Z",
    fill: "#272525"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4451 172.53L45.1474 217.677C49.7856 225.656 61.3403 231.202 61.3403 231.202L110.064 175.389L81.4451 172.53Z",
    fill: "#272525"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3149 250.018L81.2545 275.886C81.2545 275.886 87.0182 276.966 97.3475 275.596L99.308 250.018H83.3149Z",
    fill: "#E89B8C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8649 286.896H56.0848C56.0848 286.896 55.4676 279.49 63.1102 278.355C71.2883 277.139 79.2849 276.531 79.893 275.333C80.4921 274.134 79.5481 272.119 80.4104 270.885C81.0185 270.005 82.734 269.297 83.3149 270.331C84.395 272.256 83.2151 274.28 84.7763 274.743C89.1422 276.022 94.9603 274.997 95.986 273.717C97.0116 272.428 99.417 274.252 98.2188 277.248C96.8664 280.615 98.8179 284.019 97.8739 286.905L97.8649 286.896Z",
    fill: "#F8C358"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0667 288.957H97.8648V286.905H56.0667V288.957Z",
    fill: "#272525"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2341 278.056C72.6226 277.039 79.3393 276.431 79.8839 275.342V279.163C79.8839 279.163 66.0783 282.231 65.2341 278.056Z",
    fill: "#272525"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.008 170.678C197.318 179.174 198.798 210.588 168.636 210.588C138.474 210.588 126.511 206.014 117.67 210.307C108.829 214.6 103.42 262.543 103.42 262.543C91.8289 265.657 81.8354 260.792 81.8354 260.792C81.8354 260.792 85.1938 195.848 95.6592 185.982C106.125 176.115 138.41 170.951 138.41 170.951L192.008 170.678Z",
    fill: "#272525"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.008 170.678C197.318 179.174 198.798 210.588 168.636 210.588C138.474 210.588 126.511 206.014 117.67 210.307C108.829 214.6 103.42 262.543 103.42 262.543C91.8289 265.657 81.8354 260.792 81.8354 260.792C81.8354 260.792 85.1938 195.848 95.6592 185.982C106.125 176.115 138.41 170.951 138.41 170.951L192.008 170.678Z",
    fill: "#272525"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1008 257.451C99.5713 257.451 100.933 257.397 102.022 257.279C102.222 257.261 102.367 257.079 102.349 256.87C102.331 256.671 102.149 256.526 101.94 256.544C96.6849 257.116 86.3556 256.217 84.6764 255.037C84.513 254.919 84.277 254.964 84.159 255.128C84.041 255.291 84.0864 255.527 84.2498 255.645C85.7747 256.716 92.7274 257.451 98.1008 257.451Z",
    fill: "#378B86"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3581 257.451C96.5487 257.451 96.7121 257.297 96.7303 257.097C96.7484 256.689 99.0085 216.152 107.904 204.807L111.816 206.704C111.961 206.776 112.142 206.74 112.251 206.613C112.36 206.486 112.369 206.304 112.279 206.168L110.173 203.046C116.463 197.1 131.294 197.146 145.663 197.2C158.007 197.246 169.661 197.282 175.017 193.452C175.18 193.334 175.216 193.107 175.098 192.934C174.98 192.771 174.754 192.725 174.581 192.853C169.416 196.547 157.88 196.51 145.654 196.465C130.977 196.411 115.8 196.356 109.429 202.737C109.301 202.864 109.283 203.055 109.383 203.2L110.899 205.442L107.949 204.008C107.795 203.935 107.613 203.971 107.504 204.108C98.3096 215.317 96.0767 255.355 95.986 257.052C95.9769 257.252 96.1312 257.433 96.3309 257.442H96.349L96.3581 257.451Z",
    fill: "#378B86"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.008 170.678C198.707 183.876 195.467 210.589 168.645 210.589C125.866 210.589 81.4542 172.521 81.4542 172.521C81.4542 172.521 89.7866 161.484 98.5093 160.177C112.288 158.116 138.42 170.951 138.42 170.951L192.008 170.678Z",
    fill: "#272525"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9061 222.915C60.0241 222.915 60.133 222.86 60.2057 222.76C60.5143 222.334 90.2858 181.561 95.8589 176.769L96.7393 180.463C96.7756 180.617 96.9118 180.735 97.0752 180.744C97.2386 180.771 97.3838 180.653 97.4473 180.508L99.2082 175.752C104.11 175.634 123.761 185.419 132.084 189.685C138.937 193.197 158.252 199.469 171.005 195.276C175.834 193.688 179.328 190.756 181.416 186.571C181.507 186.39 181.434 186.163 181.252 186.081C181.071 185.991 180.844 186.063 180.762 186.245C178.774 190.248 175.416 193.052 170.787 194.577C158.252 198.707 139.2 192.499 132.429 189.031C121.845 183.612 103.429 174.554 98.9177 175.035C98.7816 175.053 98.6545 175.144 98.6091 175.271L97.1841 179.11L96.4489 176.052C96.4217 175.934 96.34 175.843 96.231 175.797C96.1221 175.752 95.9951 175.761 95.8952 175.825C91.5565 178.593 60.9227 220.546 59.6157 222.334C59.4977 222.497 59.534 222.733 59.6974 222.851C59.7609 222.896 59.8426 222.924 59.9152 222.924L59.9061 222.915Z",
    fill: "#378B86"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2191 225.683C63.3371 225.683 63.4551 225.62 63.5277 225.52C63.6366 225.347 63.5913 225.12 63.4188 225.011C63.3099 224.939 52.7809 218.068 50.6388 214.02C50.539 213.838 50.3211 213.774 50.1396 213.865C49.9581 213.965 49.8945 214.183 49.9853 214.364C52.2182 218.585 62.5837 225.338 63.0194 225.629C63.083 225.665 63.1556 225.692 63.2191 225.692V225.683Z",
    fill: "#378B86"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.816 188.215C187.007 188.215 187.17 188.06 187.189 187.87C187.198 187.67 187.043 187.488 186.844 187.479C183.876 187.325 180.399 185.355 178.393 182.696C177.123 181.017 176.614 179.265 176.95 177.785C176.995 177.586 176.868 177.386 176.669 177.341C176.469 177.295 176.269 177.422 176.224 177.622C175.834 179.319 176.396 181.28 177.794 183.141C179.954 186.009 183.576 188.042 186.798 188.215C186.798 188.215 186.807 188.215 186.816 188.215Z",
    fill: "#378B86"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7378 104.818L99.0902 106.724C99.0902 106.724 108.503 116.971 112.85 122.572L111.453 101.804C111.453 101.804 108.131 98.9359 106.116 96.939C106.116 96.939 104.691 84.277 103.973 83.5146C102.694 82.144 102.367 90.5036 101.722 89.7865C99.9162 87.7806 98.7997 86.292 98.4276 86.0651C98.4276 86.0651 92.6911 74.6376 91.9468 76.462C91.2025 78.2864 94.6608 86.7277 94.6608 86.7277C94.6608 86.7277 87.0273 79.3393 85.4207 80.1108C83.8141 80.8823 86.401 84.041 86.401 84.041C86.401 84.041 83.8867 81.1274 83.5509 82.5615C83.206 83.9956 86.1922 87.5537 86.1922 87.5537C86.1922 87.5537 81.9715 86.7731 82.4254 88.2163C82.8792 89.6595 97.7468 104.827 97.7468 104.827L97.7378 104.818Z",
    fill: "#E89B8C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3919 84.0317L92.0557 89.6593",
    stroke: "#BC685C",
    strokeWidth: 0.84,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M86.174 87.5444L90.3765 91.6017",
    stroke: "#BC685C",
    strokeWidth: 0.84,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0041 85.938C95.8316 86.5189 88.4341 93.281 88.4341 93.281",
    stroke: "#BC685C",
    strokeWidth: 0.84,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.078 91.9282C101.078 91.9282 99.308 96.3758 100.597 98.7902",
    stroke: "#BC685C",
    strokeWidth: 0.84,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M125.367 114.248C125.367 114.248 156.972 74.8554 167.238 91.9922C172.512 100.787 137.276 131.331 125.694 137.866C124.351 138.628 122.644 138.274 121.691 137.058L98.8723 106.424L107.123 97.9374L125.367 114.248Z",
    fill: "#E89B8C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.367 114.248C125.367 114.248 153.932 70.4259 164.197 87.5627C169.471 96.3581 152.252 132.229 125.422 138.429C123.915 138.773 122.372 138.837 121.419 137.621L98.8723 106.415L110.191 95.0419L125.367 114.239V114.248Z",
    fill: "#378B86"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.779 114.03C143.076 103.374 147.587 93.4535 153.759 84.5129C157.898 82.7974 161.62 83.2603 164.197 87.5536C168.554 94.824 157.744 120.175 138.728 132.274C138.882 126.148 139.481 120.048 140.779 114.03Z",
    fill: "#378B86"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 89.8049C102.403 89.4237 102.775 82.2168 103.973 83.5057C104.318 83.8688 104.818 86.9185 105.244 90.0228C103.783 89.932 101.804 90.0228 101.804 90.0228L101.84 89.814V89.8049Z",
    fill: "#E89B8C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 101.241C198.19 90.7396 181.425 81.2907 181.425 81.2907L175.525 77.1245L175.57 77.4513L165.078 86.0923L161.865 83.3239L162.037 81.5267L158.869 82.5978C157.517 82.7702 151.263 89.6322 149.23 92.809C147.024 96.2491 145.763 100.234 145.563 104.346L138.637 170.95L193.588 176.932C193.588 176.932 199.252 117.398 198.607 101.232V101.241Z",
    fill: "#378B86"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.129 64.7806L177.976 80.0203L172.675 87.4269C164.37 98.4188 162.4 91.8926 160.576 91.221L159.94 72.8316L168.273 68.4929L173.138 64.7715L173.129 64.7806Z",
    fill: "#E89B8C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M151.354 46.6272C150.637 68.7834 152.098 75.2007 154.313 76.6892C157.499 78.8313 162.691 76.8254 165.196 75.5728C169.298 73.5215 171.849 68.6927 172.657 67.2495C173.056 66.5415 178.538 67.1133 177.304 62.0667C176.387 58.3543 174.508 59.7612 173.583 60.7597C173.31 61.0501 172.829 60.9684 172.666 60.6053C171.686 58.4542 168.4 50.2942 167.32 47.6801C166.848 46.5455 161.756 47.2445 161.238 47.2172C156.754 47.0175 152.797 47.5349 151.581 46.7543L151.363 46.6182L151.354 46.6272Z",
    fill: "#E89B8C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.322 76.6893C157.508 78.8314 162.7 76.8254 165.205 75.5728C169.307 73.5215 171.858 68.6927 172.666 67.2495",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.71 64.018C173.71 64.018 174.49 58.8443 176.46 61.7398",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M155.738 60.0602C155.774 60.6774 156.046 61.1585 156.355 61.1403C156.664 61.1221 156.882 60.6138 156.845 59.9966C156.809 59.3794 156.537 58.8984 156.228 58.9165C155.919 58.9347 155.702 59.443 155.738 60.0602Z",
    fill: "#272525"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M152.089 59.7247C152.125 60.3419 152.398 60.823 152.706 60.8049C153.015 60.7867 153.233 60.2784 153.196 59.6612C153.16 59.044 152.888 58.5629 152.579 58.5811C152.271 58.5992 152.053 59.1075 152.089 59.7247Z",
    fill: "#272525"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M160.158 55.6491C161.011 56.1665 159.586 53.6976 158.452 53.4798C157.317 53.2619 156.246 53.8792 156.056 54.8504C156.056 54.8504 158.107 54.4056 160.158 55.6491Z",
    fill: "#272525"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M151.163 55.2862C152.334 55.0684 153.187 55.2227 153.187 55.2227C152.979 54.315 152.08 53.725 151.054 53.7614",
    fill: "#272525"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M153.786 59.5976L152.361 64.3901C152.334 64.4718 152.389 64.5444 152.47 64.5535L154.476 64.5898C154.549 64.5898 154.603 64.5263 154.594 64.4537L154.013 59.6249C153.995 59.4978 153.832 59.4796 153.786 59.5976Z",
    fill: "#E89B8C"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M153.06 67.2856C153.36 68.5473 155.32 69.691 158.234 68.511",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 59.5704C175.471 59.5704 173.428 60.9228 172.194 63.0831L167.565 49.9945C167.565 49.9945 162.119 47.3804 159.895 49.5316C157.662 51.6828 154.122 50.4483 152.452 50.0217C150.782 49.5951 149.13 47.1353 149.13 47.1353C149.13 47.1353 146.171 41.7529 149.239 39.3748C152.316 36.9967 165.922 35.8439 171.522 38.5942C176.932 41.2446 179.092 43.8224 176.151 59.752",
    fill: "#272525"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M183.549 153.297C176.523 153.487 162.836 157.254 162.836 157.254C162.836 157.254 142.114 157.072 141.723 156.001C141.342 154.93 147.896 153.505 147.896 153.505C146.915 152.997 140.326 153.505 140.117 152.861C139.899 152.207 148.041 151.263 148.104 150.819C148.159 150.374 139.708 151.409 139.536 150.465C139.363 149.521 147.814 148.486 148.014 148.068C148.213 147.66 139.518 148.332 139.817 147.179C140.117 146.026 153.242 146.507 153.859 145.799C154.476 145.091 148.976 143.103 147.796 141.261C146.616 139.418 159.06 143.857 159.06 143.857C161.665 144.138 181.643 141.488 181.643 141.488L183.558 153.278L183.549 153.297Z",
    fill: "#E89B8C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M160.086 157.218C161.547 152.471 162.999 147.715 164.515 142.986C171.114 141.524 181.643 141.497 181.643 141.497L183.558 153.288C176.533 153.478 162.845 157.245 162.845 157.245C162.845 157.245 161.756 157.236 160.095 157.209L160.086 157.218Z",
    fill: "#272525"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M186.108 139.827C186.108 139.827 173.619 90.976 194.132 94.7882C209.372 97.6202 213.538 152.08 210.026 159.006L163.58 157.971L161.502 140.616L186.118 139.827H186.108Z",
    fill: "#378B86"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M210.026 159.006L163.58 157.971L161.502 140.617L186.118 139.827C186.118 139.827 179.691 118.86 184.211 105.272",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9903 147.333H151.172V128.508H98.9903V147.333Z",
    fill: "#7798FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9903 147.333H151.172V128.508H98.9903V147.333Z",
    fill: "#7798FF"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0019 147.333H120.384V128.508H80.0019V147.333Z",
    fill: "#7798FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9928 143.693H115.791V132.139H79.9928V143.693Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M115.8 135.724H80.0019",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M115.8 138.429H80.0019",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M115.8 141.533H80.0019",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M120.384 128.508V147.333",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M124.95 128.508V147.333",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M145.962 131.113V144.728",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M129.96 131.113V144.728",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M59.779 133.909L64.8166 132.266L57.4463 106.225L52.4178 107.858L59.779 133.909Z",
    fill: "#7798FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8898 109.51L55.1409 108.748",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2892 110.936L54.7143 110.455",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6977 112.36L55.1136 111.879",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M54.097 113.786L55.5221 113.305",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4964 115.211L56.7474 114.448",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9048 116.636L56.3299 116.155",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3042 118.052L56.7293 117.571",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7127 119.477L57.1377 118.996",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1121 120.902L58.3631 120.139",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5114 122.327L57.9365 121.846",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9199 123.752L58.3449 123.271",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3192 125.177L58.7443 124.696",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7277 126.602L59.9787 125.839",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1271 128.027L59.5521 127.546",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5265 129.452L59.9515 128.971",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9349 130.868L60.3599 130.396",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3343 132.293L61.5853 131.54",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3537 136.967L62.0754 137.185L61.0316 112.324L63.3189 112.097L64.3537 136.967Z",
    fill: "#F8C358"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0178 138.274L62.5111 138.42C62.2933 138.438 62.1117 138.274 62.1027 138.047L62.0663 137.194L64.3446 136.967L64.3809 137.82C64.39 138.047 64.2266 138.247 64.0088 138.274H64.0178Z",
    fill: "#F8C358"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0754 137.185L64.3537 136.967",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0316 112.324L62.0845 110.037L63.3189 112.097",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0845 110.037L61.6216 111.053L62.6291 110.953L62.0845 110.037Z",
    fill: "#272525"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7108 137.458L78.0414 111.88L64.9165 109.747L62.7108 137.458ZM72.4683 114.693L67.6304 122.772L68.3293 114.022L72.4683 114.693Z",
    fill: "#494949"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7894 111.317L66.6319 111.616",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6532 113.05L65.7334 113.232",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5171 114.784L65.5972 114.957",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3809 116.518L65.461 116.69",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2448 118.251L66.0873 118.551",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0995 119.985L65.1797 120.157",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9634 121.709L65.0435 121.891",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8272 123.443L64.9074 123.625",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6911 125.177L65.5337 125.476",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M63.555 126.911L64.6351 127.083",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4097 128.644L64.4899 128.817",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2736 130.369L64.3537 130.55",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1374 132.103L64.98 132.402",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6376 105.907L76.8069 106.615L70.0448 130.686L67.8845 129.969L74.6376 105.907Z",
    fill: "#F8C358"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3546 104.8L76.7797 105.272C76.9794 105.335 77.0974 105.571 77.0338 105.798L76.7978 106.624L74.6285 105.907L74.8645 105.081C74.928 104.863 75.1459 104.736 75.3456 104.8H75.3546Z",
    fill: "#494949"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8069 106.615L74.6376 105.907",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0448 130.686L68.3747 132.429L67.8845 129.969",
    fill: "#F8C358"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3747 132.429L69.119 131.658L68.1568 131.34L68.3747 132.429Z",
    fill: "#272525"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1822 115.719L77.6511 117.153L68.3384 135.942L65.8695 134.508L75.1822 115.719Z",
    fill: "#7798FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6501 134.971L76.0173 116.082",
    stroke: "white",
    strokeWidth: 0.54,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6395 135.924L77.0974 116.835",
    stroke: "white",
    strokeWidth: 0.54,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2971 114.648C77.9778 115.047 78.232 115.964 77.8689 116.699L77.642 117.153L75.1731 115.719L75.4 115.265C75.7631 114.53 76.6163 114.248 77.2971 114.648Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6511 117.153L75.1822 115.719",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3384 135.941L66.287 136.867L65.8695 134.507",
    fill: "#F8C358"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M66.287 136.868L67.2038 136.459L66.1055 135.824L66.287 136.868Z",
    fill: "#272525"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M73.739 126.801H57.41V147.333H73.739V126.801Z",
    fill: "#B52200"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M73.739 126.801V147.333H57.41V134.97",
    stroke: "#272525",
    strokeWidth: 0.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M26.513 153.814L259.984 153.814V147.333L26.513 147.333V153.814Z",
    fill: "#494949"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M252.713 291.408H259.294L244.835 153.814H238.254L252.713 291.408Z",
    fill: "#494949"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M256.68 295.211C258.74 294.956 260.211 293.078 259.947 291.017L258.967 283.093L251.497 284.019L252.477 291.943C252.731 294.003 254.61 295.474 256.671 295.211H256.68Z",
    fill: "#272525"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7834 290.926H27.2028L41.662 153.333H48.2426L33.7834 290.926Z",
    fill: "#494949"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8078 294.729C27.7474 294.475 26.277 292.596 26.5402 290.536L27.5205 282.612L34.9906 283.538L34.0103 291.462C33.7562 293.522 31.8773 294.992 29.8169 294.729H29.8078Z",
    fill: "#272525"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42.851 182.133H244.299L241.186 153.814H44.267L42.851 182.133Z",
    fill: "#494949"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M259.984 153.814H26.513",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M127.473 122.753H100.179V128.808H127.473V122.753Z",
    fill: "#494949"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M116.717 115.447H110.935L108.793 125.776H118.85L116.717 115.447Z",
    fill: "#494949"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7472 108.312L131.993 68.0664",
    stroke: "#272525",
    strokeWidth: 0.62,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M112.279 110.627C124.891 110.627 135.116 100.403 135.116 87.7901C135.116 75.1776 124.891 64.9531 112.279 64.9531C99.6661 64.9531 89.4417 75.1776 89.4417 87.7901C89.4417 100.403 99.6661 110.627 112.279 110.627Z",
    fill: "#F8C358"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M128.417 71.6426L96.1312 103.928",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M128.417 103.928L96.1312 71.6426",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16689_2119",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 64,
    width: 47,
    height: 47
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M112.279 110.627C124.891 110.627 135.116 100.403 135.116 87.7901C135.116 75.1776 124.891 64.9531 112.279 64.9531C99.6661 64.9531 89.4417 75.1776 89.4417 87.7901C89.4417 100.403 99.6661 110.627 112.279 110.627Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16689_2119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.762 88.1349C147.374 88.1349 157.599 77.9104 157.599 65.2979C157.599 52.6854 147.374 42.4609 134.762 42.4609C122.149 42.4609 111.925 52.6854 111.925 65.2979C111.925 77.9104 122.149 88.1349 134.762 88.1349Z",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7866 133.11C102.399 133.11 112.624 122.885 112.624 110.273C112.624 97.6605 102.399 87.436 89.7866 87.436C77.1741 87.436 66.9496 97.6605 66.9496 110.273C66.9496 122.885 77.1741 133.11 89.7866 133.11Z",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.613 117.961C132.225 117.961 142.45 107.737 142.45 95.1241C142.45 82.5116 132.225 72.2871 119.613 72.2871C107 72.2871 96.7757 82.5116 96.7757 95.1241C96.7757 107.737 107 117.961 119.613 117.961Z",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8699 96.6671C79.9565 87.7538 79.9565 73.2946 88.8699 64.3813C97.7832 55.468 112.242 55.468 121.156 64.3813C130.069 73.2946 130.069 87.7538 121.156 96.6671C112.242 105.58 97.7832 105.58 88.8699 96.6671Z",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M130.368 69.6909C140.516 79.8387 140.516 96.2856 130.368 106.433C120.221 116.581 103.774 116.581 93.626 106.433",
    stroke: "#272525",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M114.575 112.733H112.95V115.447H114.575V112.733Z",
    fill: "#272525"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9162 171.368C71.8147 166.295 68.4201 161.448 63.3462 160.549C58.2723 159.65 53.4254 163.045 52.5268 168.119C51.6282 173.193 55.0229 178.04 60.0967 178.938C65.1706 179.837 70.0176 176.442 70.9162 171.368Z",
    fill: "#F8C358"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6639 166.884C64.0088 167.865 63.8726 168.8 63.3553 168.981C62.8379 169.163 62.139 168.518 61.7941 167.538C61.4492 166.558 61.5853 165.623 62.1027 165.441C62.6201 165.26 63.319 165.904 63.6639 166.884Z",
    fill: "#272525"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M60.124 168.137C60.4689 169.117 60.3327 170.052 59.8154 170.234C59.298 170.415 58.5991 169.771 58.2542 168.79C57.9092 167.81 58.0454 166.875 58.5628 166.694C59.0801 166.512 59.779 167.157 60.124 168.137Z",
    fill: "#272525"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M66.759 166.549C67.8664 169.689 66.2235 173.139 63.083 174.246C59.9424 175.353 56.4933 173.71 55.3859 170.57",
    stroke: "#272525",
    strokeWidth: 0.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M232.799 251.824C226.264 245.344 223.014 235.704 224.303 226.591C225.61 226.391 226.763 227.417 227.671 228.388C230.657 231.592 233.389 235.132 235.023 239.199C236.657 243.265 237.101 247.939 235.531 252.033",
    fill: "#378B86"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M233.416 251.906C228.669 246.151 221.317 242.63 213.856 242.557C215.78 246.097 218.594 249.228 222.17 251.08C225.746 252.932 230.121 253.404 233.861 251.906",
    fill: "#378B86"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M249.437 253.403C248.601 247.803 248.511 242.03 249.809 236.512C251.098 230.993 253.839 225.738 258.041 221.944C258.432 221.599 258.894 221.236 259.412 221.317C260.928 227.689 260.791 234.451 259.012 240.76C257.742 245.271 255.482 249.727 251.606 252.351",
    fill: "#378B86"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M269.178 248.348C267.381 255.645 270.685 263.905 277.012 267.953C279.78 264.776 280.306 259.984 278.754 256.063C277.202 252.142 273.798 249.119 269.904 247.531",
    fill: "#378B86"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M242.329 230.902C235.894 226.972 229.913 222.053 225.783 215.735C221.653 209.427 219.502 201.594 220.981 194.196C230.793 199.07 238.563 207.911 242.139 218.268C243.491 222.189 244.217 226.691 242.275 230.349",
    fill: "#378B86"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M252.759 251.797C255.536 248.593 258.849 245.135 263.088 245.08C266.219 245.035 269.115 246.977 270.976 249.492C272.836 252.006 273.826 255.047 274.697 258.051",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M241.594 251.661C244.072 244.145 243.428 235.876 241.195 228.279C238.971 220.682 235.241 213.629 231.537 206.631",
    stroke: "#272525",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 296.001H235.295C226.672 296.001 219.683 289.012 219.683 280.389L227.026 250.926H259.748L268.262 280.389C268.262 289.012 261.273 296.001 252.65 296.001Z",
    fill: "#7798FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M231.701 261.6C232.908 261.6 232.917 259.721 231.701 259.721C230.484 259.721 230.484 261.6 231.701 261.6Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M243.909 270.949C245.116 270.949 245.125 269.07 243.909 269.07C242.693 269.07 242.693 270.949 243.909 270.949Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M228.696 279.408C229.903 279.408 229.913 277.529 228.696 277.529C227.48 277.529 227.48 279.408 228.696 279.408Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M257.079 261.6C258.286 261.6 258.295 259.721 257.079 259.721C255.863 259.721 255.863 261.6 257.079 261.6Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M260.419 278.746C261.627 278.746 261.636 276.867 260.419 276.867C259.203 276.867 259.203 278.746 260.419 278.746Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M244.726 291.426C245.933 291.426 245.942 289.547 244.726 289.547C243.509 289.547 243.509 291.426 244.726 291.426Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16689_2119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280.198,
    height: 296,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.089a1cade99ca2c212d1c0e6595276ad.svg";
export { ForwardRef as ReactComponent };